const GET_EXPORT_COPART_PREVIEW_FILE_STATE = 'getExportCopartPreviewFileState';
const EXPORT_COPART_PREVIEW_FILE_STATE = 'exportCopartPreviewFileState';

export {
  GET_EXPORT_COPART_PREVIEW_FILE_STATE,
  EXPORT_COPART_PREVIEW_FILE_STATE,
};
